import {PriceGroup} from './PriceGroup';

export class MainProductPriceGroup extends PriceGroup {
    constructor(id: number, name: string, price: number, nameTranslated: string) {
        super(id, name, price, nameTranslated);
    }
}